export default __webpack_public_path__ + "static/media/jack.c74c6e98.png";